import moment from 'moment';

moment().format();
moment.updateLocale('es', {
    relativeTime: {
        future: "Dentro de %s",
        past:   "Hace %s",
        s  : 'Algunos segundos',
        ss : '%d segundos',
        m:  "un minuto",
        mm: "%d minutos",
        h:  "una hora",
        hh: "%d horas",
        d:  "un dia",
        dd: "%d dias",
        w:  "una semana",
        ww: "%d semanas",
        M:  "un mes",
        MM: "%d meses",
        y:  "un año",
        yy: "%d años"
    }
})

export const fromNow = (Fecha) => {
    // TODO ERROR EN NaN
    const t = moment(Fecha, "MM/DD/YY hh:mm:ss");
    return(t.fromNow())
}

export const dateTimeString = (Fecha) => {
    const t = moment(Fecha, "MM/DD/YY hh:mm:ss A");
    return t.format('DD/MM/YY hh:mm A')
}
export const dateString = (Fecha) => {
    const t = moment(Fecha, "MM/DD/YY hh:mm:ss");
    return t.format('DD/MM/YY')
}
export const fechaString = (Fecha) => {
    const t = moment(Fecha, "YYYY-MM-DD");
    return t.format('DD/MM/YY')
}

export const formatHour = (Hora) => {
    if (!Hora) return "";

    const fecha = new Date(Hora);

    fecha.setHours(fecha.getHours() - 6); 

    return moment(fecha).utcOffset(360).format("h:mm A");
};